import EpisodePlayer from './EpisodePlayer';

export default EpisodePlayer;
